/* eslint-disable */
import {useEffect, useRef} from 'react';
import {Animated, Easing, Platform, StyleSheet, View} from 'react-native';
import {colors} from '../../config/theme';

const SIZE = 140; // the box the pulse rings grow to fill
// The native animation driver doesn't exist on web (it falls back to JS there).
const USE_NATIVE_DRIVER = Platform.OS !== 'web';

// A dot that blinks, with two rings that expand and fade (radar / beacon look).
const Ring = ({progress, color}) => {
  const scale = progress.interpolate({
    inputRange: [0, 1],
    outputRange: [0.15, 1],
  });
  const opacity = progress.interpolate({
    inputRange: [0, 1],
    outputRange: [0.5, 0],
  });
  return (
    <Animated.View
      style={[
        styles.ring,
        {backgroundColor: color, opacity, transform: [{scale}]},
      ]}
    />
  );
};

const PulsingLocation = ({color = colors.primary}) => {
  const ring1 = useRef(new Animated.Value(0)).current;
  const ring2 = useRef(new Animated.Value(0)).current;
  const blink = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    const pulse = value =>
      Animated.loop(
        Animated.timing(value, {
          toValue: 1,
          duration: 2000,
          easing: Easing.out(Easing.quad),
          useNativeDriver: USE_NATIVE_DRIVER,
        }),
      );

    const a1 = pulse(ring1);
    // second ring starts half a cycle later, so the rings are staggered
    const a2 = Animated.sequence([Animated.delay(1000), pulse(ring2)]);
    const b = Animated.loop(
      Animated.sequence([
        Animated.timing(blink, {
          toValue: 0.3,
          duration: 700,
          useNativeDriver: USE_NATIVE_DRIVER,
        }),
        Animated.timing(blink, {
          toValue: 1,
          duration: 700,
          useNativeDriver: USE_NATIVE_DRIVER,
        }),
      ]),
    );

    a1.start();
    a2.start();
    b.start();
    // stop the animations when the screen is closed
    return () => {
      a1.stop();
      a2.stop();
      b.stop();
    };
  }, [ring1, ring2, blink]);

  return (
    <View style={styles.box}>
      <Ring progress={ring1} color={color} />
      <Ring progress={ring2} color={color} />
      <Animated.View
        style={[styles.dot, {backgroundColor: color, opacity: blink}]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  box: {
    width: SIZE,
    height: SIZE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  ring: {
    position: 'absolute',
    width: SIZE,
    height: SIZE,
    borderRadius: SIZE / 2,
  },
  dot: {
    width: 22,
    height: 22,
    borderRadius: 11,
    borderWidth: 3,
    borderColor: colors.surface,
  },
});

export default PulsingLocation;